/**************************************************
 * Nombre:       Home_Plan
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_plan.png'
import Tarjeta_Plan from "../../Tarjetas/Tarjeta_Plan";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Plan = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mb: 16}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 18}}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{fontSize: sCell ? 28 : 36, fontWeight: 600, lineHeight: 1.1}}>Plan de
                                Compensación</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                                El plan de compensación de BitNova World combina rendimientos diarios y bonos por red en
                                un modelo claro, justo y sostenible.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={sCell ? 2 : 4}
                            >

                                {item.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 6, md: 4}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Plan item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>


                    </Grid>


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Plan

const item = [


    {
        nombre: 'Rendimientos diarios',
        descripcion: 'BitNova World ofrece un rendimiento fijo del 1% diario, los siete días de la semana. Este porcentaje se calcula sobre el capital activo que tengas en la plataforma y se va acumulando día a día sin interrupción.'
    },
    {
        nombre: 'Retiros de rendimientos',
        descripcion: 'Están habilitados los días jueves. Puedes elegir entre la opción Premium con un 14% y un tiempo de procesamiento de 16 a 32 horas, o la opción Standard con un 10% y un tiempo de procesamiento de 24 a 72 horas.'
    },
    {
        nombre: 'Condiciones de inversión',
        descripcion: 'Se aceptan depósitos en USDT (TRC20) y en LTC, con un monto mínimo de inversión de 30 USD. El mismo valor aplica como monto mínimo para realizar retiros desde la plataforma.'
    },
    {
        nombre: 'Retiros de bonos',
        descripcion: 'Los bonos generados por tu red pueden retirarse todos los días y están disponibles a partir de un monto mínimo de 15 USD, sin limitación al día específico.'
    },
    {
        nombre: 'Membresía',
        descripcion: 'La membresía de BitNova World tiene un valor equivalente al 5% del capital invertido y puede pagarse directamente con las ganancias generadas dentro de la plataforma.'
    },
    {
        nombre: 'Bono Unilevel',
        descripcion: 'El sistema de referidos de BitNova World se basa en un esquema Unilevel que premia la expansión de tu red hasta seis niveles, con porcentajes decrecientes en cada uno de ellos para que obtengas ingresos adicionales por la actividad de tú equipo.'
    }
]